import * as React from 'react';
import Icon from '@ant-design/icons';

/* babel-plugin-inline-import './formCalendar.svg' */
var formCalendarIconSrc = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjE0IiB2aWV3Qm94PSIwIDAgMTQgMTQiIHdpZHRoPSIxNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjOGQ5MzljIj48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im0xMyAyaC0xMnYxMWgxMnptLTEgMWgtMTB2OWgxMHoiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGQ9Im0xIDVoMTJ2MWgtMTJ6Ii8+PHBhdGggZD0ibTQgMWgxdjNoLTF6Ii8+PHBhdGggZD0ibTkgMWgxdjNoLTF6Ii8+PC9nPjwvc3ZnPg==";

/* babel-plugin-inline-import './formDropdown.svg' */
var formDropdownIconSrc = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjEyIiB2aWV3Qm94PSIwIDAgMTIgMTIiIHdpZHRoPSIxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im0uNTc1Njg0IDQuNDI0MjEuODQ4NTI2LS44NDg1MyA0LjU3NTc0IDQuNTc1NzQgNC41NzU3NS00LjU3NTc0Ljg0ODUuODQ4NTMtNS40MjQyNSA1LjQyNDI3eiIgZmlsbD0iIzhkOTM5YyIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export var FormDropdownIcon = function FormDropdownIcon(props) {
  return /*#__PURE__*/React.createElement(Icon, {
    className: "no-pointer-events .icons-form-dropdown ".concat(props.className),
    component: function component() {
      return /*#__PURE__*/React.createElement("img", {
        src: formDropdownIconSrc,
        alt: ""
      });
    }
  });
};
export var FormCalendarIcon = function FormCalendarIcon(props) {
  return /*#__PURE__*/React.createElement(Icon, {
    className: "no-pointer-events .icons-form-calendar ".concat(props.className),
    component: function component() {
      return /*#__PURE__*/React.createElement("img", {
        src: formCalendarIconSrc,
        alt: ""
      });
    }
  });
};
export default {
  FormDropdownIcon: FormDropdownIcon,
  FormCalendarIcon: FormCalendarIcon
};